export const abschlag = {
    AbschlagClass: {
        url: "Finanzierung/abschlag",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_AbschlagClass_abschlagReducer'
    }
};